import { Navigate, useLocation } from 'react-router-dom';
import { SessionGate } from '@/components/SessionGate';
import { useSession } from '@/session/useSession';

/**
 * Entry route (`/room/?t=<inviteToken>`). The SessionProvider has already read the token and started
 * the exchange. Once a session is active we route to the tasks flow (preserving the invite in the URL
 * so a refresh remains recoverable); otherwise the gate shows the exchange/loading/expired/error UI.
 */
export function LandingPage() {
  const { status } = useSession();
  const { search } = useLocation();

  if (status === 'active') {
    return <Navigate to={{ pathname: '/tasks', search }} replace />;
  }
  return <SessionGate />;
}
